import { CommentInterface } from "../interfaces/comments/CommentInterface";
import { CommentsBlock } from "./CommentsBlock";
import { CommentLike } from './CommentLike';
import { CommentType, CommentAttachment } from "@api/enums/CommentTypes";
import {DateTime} from "luxon";
import {setDates} from "@api/models/helpers/DatesSetter";

export class Comment implements CommentInterface {
    id: string;
    createdAt: DateTime;
    publishedAt: DateTime;
    updatedAt: DateTime;
    isDeleted: boolean;
    isOnEdit = false;
    userId: number;
    parentId: string | null;
    text: string;
    thread: CommentsBlock | null;
    threadId: string | null;
    likes: CommentLike;
    type: CommentType;
    isPinned: boolean;
    isPublished?: boolean;
    attachments?: CommentAttachment[];

    constructor(data: CommentInterface) {
        Object.assign(this, data);
        if (this.thread) {
            this.thread = new CommentsBlock(this.thread);
        } else {
            this.thread = null;
        }
        if (this.likes) {
            this.likes = new CommentLike(this.likes);
        }
        setDates(this, ['createdAt', 'publishedAt', 'updatedAt']);
    }

    delete() {
        this.isDeleted = true;
        this.text = '';
    }

    cloneWithoutTread() {
        const copyed = { ...this };
        copyed.thread = null;
        return new Comment(copyed);
    }
}
